import React from "react";
import { CheckCircle2 } from "lucide-react";

type Props = {
  className?: string;
  size?: number;
};

export default function IconCheckCircle({ className, size = 16 }: Props) {
  return <CheckCircle2 className={className} width={size} height={size} />;
}


